<template>
  <div>
    <EmpreendimentosBanner></EmpreendimentosBanner>
    <EmpreendimentosCategorias></EmpreendimentosCategorias>
    <div class="empreendimentos">
      <div class="container">
        <div class="row">
          <EmpreendimentosCard :businesses="empreendimentos"></EmpreendimentosCard>
          <Paginacao :page="empreendimentos.current_page" :lastPage="empreendimentos.last_page" :rota="$route.name" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EmpreendimentosBanner from './EmpreendimentosBanner'
import EmpreendimentosCategorias from './EmpreendimentosCategorias'
import EmpreendimentosCard from './EmpreendimentosCard'
import Paginacao from '../paginacao'
import CtaConheca from './../CtaConheca'
import { mapGetters } from 'vuex'
export default {
  components: {
    EmpreendimentosBanner,
    EmpreendimentosCategorias,
    EmpreendimentosCard,
    CtaConheca,
    Paginacao
  },
  computed: {
    ...mapGetters([
      'empreendimentos'
    ])
  },
  created () {
    this._loadEmpreedimentos()
  },
  watch: {
    '$route' (to, from) {
      this._loadEmpreedimentos()
    }
  },
  methods: {
    _loadEmpreedimentos () {
      let params = {
        page: this.$route.query.page ? this.$route.query.page : '',
        filter: this.$route.query.filter ? this.$route.query.filter : '',
        category: this.$route.query.category ? this.$route.query.category : '',
        delivered: this.$route.query.delivered ? this.$route.query.delivered : '',
        for_sale: this.$route.query.for_sale ? this.$route.query.for_sale : ''
      }
      this.$store.dispatch('loadEmpreendimentos', params)
      this.scrollTop()
    },
    scrollTop () {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.empreendimentos {
  background: $bgIntern;
  padding-bottom: 80px;
  @media (max-width: 991px) {
    padding-bottom: 60px;
  }
  @media (max-width: 767px) {
    padding-bottom: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/Empreendimentos.vue